import { User } from 'oidc-client-ts';

function getHeaders() {
  const oidcStorage = localStorage.getItem(`oidc.user:https://cognito-idp.eu-west-1.amazonaws.com/${import.meta.env.VITE_COGNITO_POOL_ID}:${import.meta.env.VITE_COGNITO_CLIENT_ID}`)

  if (!oidcStorage) {
    return null;
  }

  const user = User.fromStorageString(oidcStorage);

  return {
    Authorization: `Bearer ${user.access_token}`,
  };
}

export {
  getHeaders,
};